module.exports = __webpack_public_path__ + "img/35.1ae45b94.jpg";